import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
const FilterWidthMappings = {
  LIST_FIXED: '320px',
  LIST_STRETCHED: '25vw',
  EVENT_FIXED: '302px',
  EVENT_STRETCHED: '20vw',
  WITH_FILTER_DETAILS: '325px',
  DEFAULT: 'initial'
};
const StyledFilterContainer = styled.div.attrs(() => ({
  'data-test-id': 'STYLED_FILTER_CONTAINER'
})).withConfig({
  displayName: "StyledFilterContainer",
  componentId: "sc-10l1e9c-0"
})(["background-color:", ";border:solid 1px ", ";border-radius:3px;padding:12px;div{overflow-wrap:break-word;inline-size:", ";}"], ({
  backgroundColor
}) => backgroundColor || 'initial', GREAT_WHITE, ({
  filterWidthType
}) => FilterWidthMappings[filterWidthType || 'LIST_FIXED']);
export default StyledFilterContainer;